/**
* @author XuZiYu
* @date 2019/8/30
* @time 09:53
* @update 2022/08/30 ZhanFuzheng 获取车型方式调整
*/
<template>
    <div class="wrapper">

        <!--头部-->
        <template v-if="!H5 && headVisible !== '0'">
            <div class="header">
                <div class="header-left" @click="goBack"><img src="@/assets/vip/icon_back1.png" alt=""/></div>
                <div class="header-main">教学视频VIP服务</div>
                <div class="header-right">
                    <img v-if="shareVisible" @click="openSharePanel" src="@/assets/public/icon_fx01.png" alt=""></div>
            </div>
            <!--头部占位-->
            <div class="header-pre"></div>
        </template>

        <!--分享框架-->
        <share-ad :detail="shareData">
            <div class="bg">
                <img src="@/assets/videoVip/picture_teachvideo1@2x.png" alt=""/>
                <img src="@/assets/videoVip/picture_teachvideo2@2x.png" alt=""/>
                <img src="@/assets/videoVip/picture_teachvideo3@2x.png" alt=""/>
                <div class="rule">
                    <p>
                        <b class="index">1.</b>教学视频VIP服务，有效期为<b class="number">{{teachVideoData.effectiveDays}}</b><b class="chinese">天</b>，购买后即刻生效。
                    </p>
                    <p><b class="index">2.</b>教学视频VIP服务为虚拟产品，不支持退款， 请知悉后再购买。</p>
                    <p><b class="index">3.</b>如有疑问，请联系{{teachVideoData.phone}}。</p>
                </div>
                <div class="rule second">
                    <p><b class="index">1.</b>购买前请注册/登录App账号，购买成功后，需要登录您购买时的账号才能享受VIP服务。<br></p>
                    <p><b class="index">2.</b>如有疑问或需要帮助，请联系平台客服咨询。</p>
                </div>
            </div>
        </share-ad>

        <!--底部-->
        <div class="footer">
            <span v-if="teachVideoData.openMode === 1" class="second">
                限时领取 <b>（分享激活）</b>
            </span>
            <span v-else class="first">
                <b v-if="teachVideoData.openMode === 3" class="top">{{teachVideoData.pointNum}}斑豆</b>
                <b v-if="teachVideoData.openMode === 2" class="top">¥{{teachVideoData.payConPrice > 0 ? teachVideoData.payConPrice : teachVideoData.payOrigPrice}}{{teachVideoData.payConPoint ? ` + ${teachVideoData.payConPoint}斑豆` : ''}}</b>
                <b v-if="teachVideoData.openMode === 2 && teachVideoData.payConPrice > 0" class="bottom">原价¥{{teachVideoData.payOrigPrice}}</b>
            </span>
            <van-button v-if="IOS" class="recovery" @click="submit" :loading="loading">恢复购买</van-button>
            <van-button class="fourth" @click="submit" :loading="loading">立即开通</van-button>
        </div>

        <!--底部占位-->
        <div class="footer-pre"></div>

        <!--消息弹出框-->
        <ctl-dialog v-model="messageDialog" :loading="loading"/>

    </div>
</template>

<script>
import dialog from '@/components/dialog/index.vue'
import { Toast, Button } from 'vant'

export default {
    name: 'teachVideo',
    components: {
        ctlDialog: dialog,
        [Button.name]: Button
    },
    methods: {
        // 返回
        goBack () {
            this.$jsBridge.callBackHandler('returnLastPage')
        },
        // 跳转app
        linkApp () {
            // 判断设备
            if (this.IOS) {
                // qq浏览器特殊处理
                if (String(navigator.userAgent.toLowerCase().match(/QQ/i)) === 'qq') {
                    let body = document.querySelectorAll('body')[0]
                    let div = document.createElement('div')
                    let img = document.createElement('img')
                    div.style = 'width: 100%;position: fixed;height: 100%;top: 0;background: rgb(0 0 0 / 80%);z-index: 9;'
                    div.onclick = () => {
                        body.removeChild(div)
                    }
                    img.src = require('@/assets/public/icon_fxts.png')
                    img.style = 'width:100%'
                    div.appendChild(img)
                    body.appendChild(div)
                    return true
                }

                // 根据分享app类型跳转
                location.href = Number(this.appType) === 2
                    ? 'https://share.banbanjiadao.com/ui/h5/bbjd/index'
                    : 'https://share.banbanjiadao.com/ui/h5/bb/index'
            } else {
                // 根据分享app类型跳转
                location.href = Number(this.appType) === 2
                    ? 'https://a.app.qq.com/o/simple.jsp?pkgname=com.banbanjiadao.activity&android_schema=banbanjiadao%3a%2f%2fopen'
                    : 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ctl.student&android_schema=chetailian%3a%2f%2fopen&ios_scheme=chetailian%3a%2f%2fopen'
            }
        },
        // 开通成功统一处理
        openSuccess () {
            // 回调App开通成功
            this.$jsBridge.callBackHandler('openSuccess', { vipVideoType: '1' })
        },
        // 斑豆开通方式
        beanOpenModel () {
            // 没有用户id && 去登录
            if (!this.userInfo.userId) {
                this.$jsBridge.hasNativeMethod('loginUserV2') ? this.$jsBridge.callBackHandler('loginUserV2') : this.$jsBridge.callBackHandler('loginUser')
                return
            }
            this.messageDialog = {
                visible: true,
                rightBtnName: '确认',
                leftBtnName: '取消',
                leftBtnMethod: () => {
                    this.messageDialog.visible = false
                },
                rightBtnMethod: () => {
                    // 请求数据
                    let postData = {
                        currentUserId: this.userInfo.userId
                    }

                    this.loading = true

                    this.$api.bbBeanOpenTeachVideo(postData).then(res => {
                        this.loading = false

                        // 开通成功
                        if (res.result === null && res.status && res.code === '200') {
                            // 开通处理
                            this.openSuccess()
                        }

                        // 斑豆异常处理
                        if (res.message.indexOf('斑豆不足') > -1) {
                            this.messageDialog = {
                                visible: true,
                                rightBtnName: '去做任务',
                                leftBtnName: '取消',
                                leftBtnMethod: () => {
                                    this.messageDialog.visible = false
                                },
                                rightBtnMethod: () => {
                                    this.messageDialog.visible = false

                                    // 跳转斑豆任务
                                    this.$jsBridge.callBackHandler('pushBandouCenterPage')
                                },
                                title: '',
                                content: res.message
                            }
                        }

                        // 处理通用错误码
                        this.handleErrorCode(res)
                    })
                },
                title: '',
                content: '是否确认开通教学视频VIP'
            }
        },
        // 金钱开通方式
        moneyOpenModel () {
            // 除了IOS设备都需要登陆
            if (!this.IOS && !this.userInfo.userId) {
                this.$jsBridge.hasNativeMethod('loginUserV2') ? this.$jsBridge.callBackHandler('loginUserV2') : this.$jsBridge.callBackHandler('loginUser')
                return
            }

            // 请求数据
            let postData = {
                currentUserId: this.userInfo.userId,
                version: this.version
            }

            this.loading = true
            this.$api.vipPayOpenTeachVideo(postData).then(res => {
                this.loading = false
                if (res.code === '200' && res.status) {
                    // 判断是否IOS && 苹果支付
                    if (this.IOS) {
                        // 兼容ios设置类型
                        this.$jsBridge.callBackHandler('setApplePayType', { payType: 1 })

                        // 唤起支付
                        this.$jsBridge.callBackHandler('applyPay', {
                            orderId: res.result,
                            productId: this.teachVideoData.productId
                        })
                        return
                    }

                    // 跳转付款页
                    this.$router.push({
                        name: 'pay',
                        query: {
                            payId: res.result,
                            money: this.teachVideoData.payConPrice > 0 ? this.teachVideoData.payConPrice : this.teachVideoData.payOrigPrice,
                            type: '4',
                            headShow: this.headVisible
                        }
                    })
                }

                // 错误状态码处理
                if (res.code === '701') {
                    this.messageDialog = {
                        visible: true,
                        rightBtnName: '去支付',
                        leftBtnName: '取消',
                        leftBtnMethod: () => {
                            this.messageDialog.visible = false
                        },
                        rightBtnMethod: () => {
                            this.$router.push({
                                name: 'teachVideoOrderDetail',
                                query: { id: res.result, headShow: this.headVisible }
                            })
                        },
                        title: '',
                        content: '您有教学视频VIP服务订单未支付'
                    }
                }

                // 斑豆异常处理
                if (res.message.indexOf('斑豆不足') > -1) {
                    this.messageDialog = {
                        visible: true,
                        rightBtnName: '去做任务',
                        leftBtnName: '取消',
                        leftBtnMethod: () => {
                            this.messageDialog.visible = false
                        },
                        rightBtnMethod: () => {
                            this.messageDialog.visible = false

                            // 跳转斑豆任务
                            this.$jsBridge.callBackHandler('pushBandouCenterPage')
                        },
                        title: '',
                        content: res.message
                    }
                }

                // 处理通用错误码
                this.handleErrorCode(res)
            })
        },
        // 分享开通方式
        shareOpenModel () {
            // 分享开通需要登陆
            if (!this.userInfo.userId) {
                this.$jsBridge.hasNativeMethod('loginUserV2') ? this.$jsBridge.callBackHandler('loginUserV2') : this.$jsBridge.callBackHandler('loginUser')
                return
            }

            // 标题
            let title = this.teachVideoData.title
            // 内容
            let content = this.teachVideoData.content
            // 分享链接
            let shareUrl = this.teachVideoData.link
            // 图片链接
            let imageUrl = this.teachVideoData.image
            // 页面编码
            let pageCode = 'studyVideo-detail'

            this.$jsBridge.callBackHandler('share', { title, content, shareUrl, imageUrl, pageCode })
        },
        // 处理错误码
        handleErrorCode (v) {
            if (v.code === '666') {
                Toast.fail(v.message)
            }

            if (v.code === '1004') {
                if (this.$jsBridge.hasNativeMethod('pushFeedBackPage')) {
                    this.messageDialog = {
                        visible: true,
                        rightBtnName: '遗憾放弃',
                        leftBtnName: '我要反馈',
                        leftBtnMethod: () => {
                            this.messageDialog.visible = false

                            // 跳转app意见反馈
                            this.$jsBridge.callBackHandler('pushFeedBackPage')
                        },
                        rightBtnMethod: () => {
                            this.messageDialog.visible = false
                        },
                        title: '温馨提示',
                        content: v.message
                    }
                } else {
                    this.messageDialog = {
                        visible: true,
                        rightBtnName: '我知道了',
                        rightBtnMethod: () => {
                            this.messageDialog.visible = false
                        },
                        title: '温馨提示',
                        content: v.message
                    }
                }
            }
        },
        // 开通
        submit () {
            // H5标记不能购买
            if (this.H5) {
                this.linkApp()
                return
            }

            // 判断是否已经购买
            if (this.vipData.vipFlag) {
                // 开通处理
                this.openSuccess()
                return
            }

            // 班豆支付
            if (this.teachVideoData.openMode === 3) {
                this.beanOpenModel()
            }
            // 金钱支付
            if (this.teachVideoData.openMode === 2) {
                this.moneyOpenModel()
            }
            // 分享激活
            if (this.teachVideoData.openMode === 1) {
                this.shareOpenModel()
            }
        },
        // 支付回调
        payCallback (v) {
            // 跳转支付结果页
            this.$router.push({ name: 'payResult', query: { result: v, headShow: this.headVisible } })
        },
        // 分享回调
        shareCallback () {
            // 判断车型 || 是否分享开通模式
            if (Number(this.carType) !== 1 || Number(this.examVideoData.openMode) !== 1) {
                return
            }
            // 请求数据
            let postData = {
                shareRecordId: this.teachVideoData.shareRecordId,
                times: '1'
            }
            this.loading = true
            this.$api.vipShareOpenTeachVideo(postData).then(res => {
                this.loading = false
                if (res.status) {
                    if (res.result === 0) {
                        // 开通成功处理
                        this.openSuccess()
                    } else {
                        Toast.success('分享成功')
                    }
                }
            })
        },
        // 获取vip数据
        getVipData () {
            let postData = {
                version: this.version
            }

            return this.$api.getVipMatchEntryTeachVideo(postData).then(res => {
                if (res.status && res.result) {
                    // 判断是否开通
                    if (res.result.vipFlag) {
                        // 开通成功
                        this.openSuccess()
                    }

                    // 设置vip数据
                    this.vipData = res.result

                    // 设置教学视频数据
                    this.teachVideoData = res.result.examVipSettingTeachVideoDTO

                    if (this.IOS && this.teachVideoData.payConPoint) {
                        this.$nextTick(() => {
                            document.querySelectorAll('.top')[0].style.fontSize = '15px'
                            document.querySelectorAll('.bottom')[0].style.fontSize = '14px'
                        })
                    }
                } else {
                    Toast.fail(res.message)
                }
            })
        },
        // 打开分享面板
        openSharePanel () {
            // 标题
            let title = this.shareData.shareTitle || '教学视频VIP'
            // 内容
            let content = '考试项目讲解，真实场地多角度全方位实操教学。'
            // 分享链接
            let shareUrl = ''
            // 图片链接
            let imageUrl = this.shareData.shareGroupImg
            // 页面编码
            let pageCode = 'studyVideo-detail'

            if (this.shareData.shareType === '1') {
                // 处理域名替换
                shareUrl = location.origin.replace('app.banbanjiadao.com', 'app.banbanjd.cn').replace('app.chetailian.com', 'app.banbanjd.cn')

                // 拼接路径
                shareUrl += location.pathname

                // 拼接参数
                shareUrl += `?shareType=h5&appType=${this.appType}`

                // 设置图片链接
                imageUrl = this.shareData.shareImg || 'http://app.static.public.chetailian.com/share/jxspVIP.png'
            }

            this.$jsBridge.callBackHandler('share', { title, content, shareUrl, imageUrl, pageCode })
        },
        // 获取分享配置信息
        getSetting () {
            return this.$api.getAdSetting({ code: 'studyVideo-detail' }).then(res => {
                if (res.status && res.result) {
                    this.shareData = res.result
                }
            })
        },
        // 刷新数据
        refreshCallBack () {
            // 重新获取app用户数据
            let userInfo = this.$jsBridge.callBackHandler('passUserInfo')

            this.userInfo = userInfo ? JSON.parse(userInfo) : {}

            // 重新获取app token
            let ctlToken = this.$jsBridge.callBackHandler('passTokenData')

            if (ctlToken) {
                localStorage.setItem('ctl-token', JSON.parse(ctlToken).token)
            }

            // 重新设置车型
            this.carType = this.$jsBridge.callBackHandler('getBankCarType') || (this.$jsBridge.callBackHandler('getCarType') || '1')

            // 刷新vip数据
            this.getVipData()

            // 检查车型
            this.checkCarType()
        },
        // 检查车型
        checkCarType () {
            const carTypeName = this.$store.getters.carTypeName

            if (Number(this.carType) !== 1 && this.$jsBridge.hasNativeMethod('pushQuestionBankSettingPage')) {
                this.messageDialog = {
                    visible: true,
                    rightBtnName: '切换题库',
                    leftBtnName: '我知道了',
                    leftBtnMethod: () => {
                        this.messageDialog.visible = false
                    },
                    rightBtnMethod: () => {
                        this.messageDialog.visible = false

                        // 进入设置题库页面
                        this.$jsBridge.callBackHandler('pushQuestionBankSettingPage')
                    },
                    title: '温馨提示',
                    content: `该服务现仅适用于小车学员，您当前车型-${carTypeName[this.carType]}，是否需切换回小车题库？`
                }
            }
        },
        // 初始化
        init () {
            // 获取用户数据
            let userInfo = this.$jsBridge.callBackHandler('passUserInfo')

            this.userInfo = userInfo ? JSON.parse(userInfo) : {}

            // 设置车型
            this.carType = this.$jsBridge.callBackHandler('getBankCarType') || (this.$jsBridge.callBackHandler('getCarType') || '1')

            // 设置H5标记
            this.H5 = this.$route.query.shareType === 'h5'

            // 设置版本
            this.version = this.$jsBridge.callBackHandler('getAppVersion') || ''

            // 设置app类型
            this.appType = this.$jsBridge.callBackHandler('getAppType') || (typeof this.$route.query.appType === 'object' ? this.$route.query.appType[0] : this.$route.query.appType)

            // 设置分享显示
            this.shareVisible = !this.H5

            // 设置头部显示
            this.headVisible = this.$route.query.headShow || '1'

            // 暴露支付回调方法
            this.$jsBridge.registerHandler('payCallback', this.payCallback)

            // 暴露分享回调方法
            this.$jsBridge.registerHandler('shareCallback', this.shareCallback)

            // 暴露刷新页面方法
            this.$jsBridge.registerHandler('refreshCallBack', this.refreshCallBack)
        }
    },
    async created () {
        // 初始化
        this.init()

        // 获取vip数据
        this.getVipData()

        // 获取分享数据
        this.getSetting()

        // 检查车型
        this.checkCarType()
    },
    data () {
        return {
            // 头部显示
            headVisible: '',
            // H5标记
            H5: false,
            // vip数据
            vipData: {},
            // 教学视频数据
            teachVideoData: {},
            // 车型默认小车
            carType: '1',
            // loading
            loading: false,
            // 显示分享
            shareVisible: false,
            // 分享数据
            shareData: {},
            // 苹果标记
            IOS: !!(navigator.userAgent).match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
            // 用户数据
            userInfo: {},
            // 弹窗数据
            messageDialog: {
                visible: false,
                rightBtnName: '',
                leftBtnName: '',
                leftBtnMethod: '',
                rightBtnMethod: '',
                title: '',
                content: ''
            }
        }
    }
}
</script>

<style lang="scss">
    .wrapper {
        .van-button {
            height: 100%;
            border: none;
        }

        .van-button__loading {
            margin: 0 auto;
            vertical-align: middle;
        }

        .header {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            z-index: 99;
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: 60px;
            background: #ffffff;

            .header-main {
                font-size: 18px;
                font-family: PingFangSC;
                font-weight: bold;
                color: #333333;
            }

            .header-share {
                position: absolute;
                height: 60px;
                display: flex;
                align-items: center;
                right: 20px;
                font-size: 0;
                line-height: 1;

                img {
                    width: 24px;
                }
            }

            .header-left, .header-right {
                display: flex;
                padding: 15px 10px;
                width: 24px;
                height: 24px;
                font-size: 0;
                line-height: 1;

                img {
                    width: 24px;
                    height: 24px;
                }
            }
        }

        .header-pre {
            height: 60px;
        }

        background: #FAFAFA;

        .password-input {
            position: relative;
            margin-top: 20px;

            input {
                opacity: 0;
                height: 100px;
                width: 100px;
                border: none;
                position: absolute;
                left: -100%;
            }

            ul {
                text-align: center;

                li {
                    vertical-align: top;
                    display: inline-block;
                    width: 40px;
                    height: 40px;
                    line-height: 40px;
                    border: 1px solid #cccccc;
                    font-size: 24px;
                    font-weight: 600;
                    color: #333333;

                    & + li {
                        border-left: none;
                    }
                }
            }
        }

        .bg {
            position: relative;
            line-height: 1;
            font-size: 0;

            img {
                width: 375px;
            }
        }

        .rule {
            &.second {
                bottom: 60px;
            }

            position: absolute;
            bottom: 200px;
            width: 275px;
            left: 50%;
            transform: translateX(-50%);

            p {
                text-indent: - 15px;
                margin-left: 15px;
                font: 400 13px PingFangSC-Regular, PingFang SC;
                color: rgba(96, 96, 96, 1);
                line-height: 24px;
                word-break: break-word;
            }

            .chinese {
                position: relative;
                top: - 1px;
                display: inline-block;
                width: 15px;
                height: 12.5px;
                margin: 0 2.5px;
                text-indent: 0;
                border-radius: 2.5px;
                text-align: center;
                line-height: 13px;
                font-size: 10px;
                color: #fff;
                background: #FF6100;
                font-weight: normal;
            }

            .index {
                text-indent: 0;
                display: inline-block;
                width: 15px;
            }

            .number {
                color: #FF6100;
                font-weight: normal;
            }
        }

        .footer-pre {
            height: 49px;
        }

        .footer {
            position: fixed;
            bottom: 0;
            width: 100%;
            height: 49px;
            border-top: 1px solid #EEEEEE;
            background: #ffffff;
            display: flex;
            justify-content: space-between;

            span {
                display: flex;
                justify-content: center;
                align-items: center;
            }

            .first {
                flex-direction: column;
                flex: 1;
                font-weight: 600;
                color: rgba(255, 80, 80, 1);

                .top {
                    color: #FF5050;
                    font-size: 18px;
                }

                .bottom {
                    color: #999999;
                    font-size: 14px;
                    text-decoration: line-through;
                }
            }

            .second {
                flex: 1;
                font-size: 17px;
                font-weight: bold;
                color: #333333;

                b {
                    font-size: 13px;
                    font-weight: normal;
                }
            }

            .third {
                width: 80px;
                background: #FFEED2;
                font-size: 18px;
                font-weight: bold;
                color: #D4A36B;
            }

            .fourth {
                border-radius: 0;
                width: 110px;
                background: #F5DDB6;
                font-size: 17px;
                font-weight: bold;
                color: #A86F2F;
            }

            .recovery {
                border-right: 1px solid #fff;
                border-radius: 0;
                width: 110px;
                background: #F5DDB6;
                font-size: 17px;
                font-weight: bold;
                color: #A86F2F;
            }
        }
    }
</style>
